import testimonial1 from './assets/testimonial-1.jpg';
import testimonial2 from './assets/testimonial-2.jpg';
import testimonial3 from './assets/testimonial-3.jpg';

export const mockData = {
  testimonials: [
    {
      id: 1,
      name: 'David Martinez',
      role: "Half Ironman - 4h 47'",
      quote: 'Antes de entrar en HUB, venía de haber dejado el deporte y de una etapa marcada por hábitos poco saludables donde también perdí ambición y confianza. En HUB entendí el papel que el deporte puede tener en mi vida, alineando mi día a día con objetivos concretos. El HUB tracking fue lo que más me ayudó.',
      image: testimonial1
    },
    {
      id: 2,
      name: 'Mario Lanceta',
      role: "Maratón - 3h 10'",
      quote: 'Siempre he hecho deporte de equipo a alto nivel durante, y partía de una buena base física pero sin experiencia en deportes de resistencia. En HUB afronté el reto de debutar en maratón, aprendiendo a estructurar mi entrenamiento y enfoque mental.',
      image: testimonial2
    },
    {
      id: 3,
      name: 'Este eres tú',
      role: 'Aplica y valoramos tu caso',
      quote: 'Quiero dejar de ir a rachas y tener un sistema alineado con lo que sueño. Sé que me toca currar y hacerme responsable. No voy a poner excusas ni buscar atajos. Soy atleta de resistencia y voy a poner el trabajo encima de la mesa.',
      image: testimonial3
    }
  ],

  hubLabBenefits: [
    {
      id: 1,
      title: 'Metodologia estructurada',
      description: 'Sistema probado que combina entrenamiento fisico, habitos y mentalidad. Progreso medible en cada sesion.'
    },
    {
      id: 2,
      title: 'Entrenamiento personalizado',
      description: 'Programas adaptados a tu nivel actual y objetivos especificos. Cuerpo y mente trabajando en sincronia.'
    },
    {
      id: 3,
      title: 'Comunidad comprometida',
      description: 'Rodeate de personas ambiciosas con mentalidad de crecimiento. Accountability y apoyo mutuo.'
    },
    {
      id: 4,
      title: 'Coaching continuo',
      description: 'Acompanamiento constante para mantener el rumbo. Ajustes estrategicos basados en tus resultados.'
    }
  ],

  socialLinks: {
    instagram: 'https://www.instagram.com/hubathletics/',
    youtube: 'https://www.youtube.com/@hubathletics',
    linkedin: ''
  }
};
